<template>
  <Popup style="background-color: rgba(0, 0, 0, 0);" v-model:show="show">
    <div class="p-box">
      <div class="p-box__card">
        <div class="p-box__title">
          <div class="card__titlebefore"></div>
          规则说明
          <div class="card__titleafter"></div>
        </div>
        <div class="p-box__content">
          <div>权益介绍：</div>
          <div>1、自2022年9月15日00:00:00后成功购买(以订单生成时间为准）极氪订阅&网易严选联合特权的用户，即可立即享受联合权益。</div>
          <div>2、网易严选Pro会员权益需使用本人注册的极氪订阅账号登录网易严选APP查看相关权益的到账情况，过期不使用权益将会失效。</div>
          <div>3、网易严选 Pro会员效期为365天，如本人在网易严选平台已存在有效的Pro会员天数，新开通的Pro会员效期将顺延其后；不论从何种渠道开通/获得该联合特权，同一个用户（含同一网易严选账号、同一手机号）
            仅可领取1次联合特权。</div>
          <div>4、网易严选 Pro会员在季卡有效期内购买联合特权，网易严选 Pro会员的效期将于季卡到期后开始生效，极氪订阅权益可在购买后立即获取，自联合特权购买/兑换成功之日起即可生效。</div>
          <div>
            5、极氪订阅权益内同类优惠券不可重复叠加使用，购买极氪订阅产品发生退款的，优惠券不再退回；优惠券须在有效期之内使用，以获取之日开始计算，过期未使用的，极氪订阅不做另外补偿，联合特权内容及使用规则以极氪订阅官方平台公布为准，使用规则详见《极氪订阅联合特权用户服务协议》。
          </div>
          <div></div>
          <div>领取规则</div>
          <div>1、开通联合特权后，请及时在我的特权页面查看联合权益内容到账情况；</div>
          <div>
            2、网易严选权益将默认发放至同极氪订阅账号绑定的手机号所对应的网易严选账户。如该手机号未开通网易严选账户，在网易严选权益获取成功后，亦可使用极氪订阅账户绑定的手机号登录网易严选，并使用相应权益。确认授权后账号不可变更，请仔细核对；
          </div>
          <div>3、联合特权限同一用户（含同一极氪订阅账号、同一手机号）领取，一经领取不可更改或取消，不可以换绑；</div>
          <div>4、如果是网易严选新用户，请务必在开通后及时去网易严选APP注册激活权益；</div>
          <div>5、如果网易严选账户绑定的手机号与极氪订阅授权手机不一致，请务必使用同一账户以免无法获取相应权益。</div>
          <div></div>
          <div>特殊说明</div>
          <div>1、无论任何原因导致用户的极氪订阅&网易严选联合特权暂停或终止，用户所开通的极氪订阅权益将同时暂停或终止。</div>
          <div>2、自2022年9月15日0点起，在极氪订阅平台下单并付费购买该极氪订阅&网易严选联合特权的用户，可享受本联合特权的权益内容；</div>
          <div>3、极氪订阅&网易严选联合特权一经出售不允退款。</div>
        </div>
      </div>
      <div class="p-box__close" @click="close"></div>
    </div>
  </Popup>
</template>
<script setup>
import { Popup } from 'vant';
import { ref, watch } from "vue";
const show = ref(false)
let na
watch(show, () => {
  if (!na) na = document.querySelector('.na')
  if (na) na.style.overflow = show.value ? 'hidden' : 'auto'
})
const close = () => {
  show.value = false
}
const open = () => {
  show.value = true
}
// eslint-disable-next-line no-undef
defineExpose({
  close,
  open
})
</script>
<style scoped>
.p-box__card {
  padding: 40px;
  font-size: 24px;
  line-height: 36px;
  color: #A2A3A4;
  border-radius: 8px;
  width: 590px;
  background-color: #171A1B;
  position: relative;
  overflow: hidden;
}

.p-box__card::after {
  content: "";
  display: block;
  background-color: #f00;
  height: 600px;
  width: 600px;
  position: absolute;
  top: 0;
  right: -300px;
  transform: rotate(45deg);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));
  z-index: 1;
}

.p-box__card>* {
  position: relative;
  z-index: 2;
}

.p-box__title {
  font-size: 32px;
  color: #FFFFFF;
  opacity: 0.9;
  text-align: center;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}

.p-box__close {
  width: 80px;
  height: 80px;
  margin: 60px auto 0;
  background: url('@/static/image/popup-close.png') center / 100% no-repeat;
}

.p-box__content {
  overflow: auto;
  max-height: 630px;
  padding: 24px;
  background: #2A2E2F;
  border-radius: 8px;
}

.p-box__content div {
  min-height: 24px;
}

.card__titlebefore,
.card__titleafter {
  margin: 0 12px;
  display: flex;
  align-items: flex-start;
}

.card__titlebefore::before,
.card__titleafter::before {
  content: '';
  display: block;
  width: 7px;
  height: 16px;
  background: linear-gradient(to bottom, #BDC0C4, rgba(0, 0, 0, 0));
  transform: skewX(45deg);
  margin: 0 3px;
}

.card__titleafter::before {
  transform: skewX(-45deg);
  height: 12px;
  ;
}

.card__titlebefore::after,
.card__titleafter::after {
  content: '';
  display: block;
  width: 7px;
  height: 12px;
  background: linear-gradient(to bottom, #BDC0C4, rgba(0, 0, 0, 0));
  transform: skewX(45deg);
  margin: 0 3px;
}

.card__titleafter::after {
  transform: skewX(-45deg);
  height: 16px;
}
</style>